<template>
  <CreateEditProfileModal
    v-if="showCreateEditProfileModal"
    :profileId="profileIdSelected"
    @closeModal="closeModal"
  />
  <div class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h4 class="py-3 mb-0">Perfis</h4>
      <div class="ms-auto my-auto">
        <button
          type="button"
          class="btn btn-dark"
          title="Cadastrar Perfil"
          @click="createEditProfile()"
        >
          Cadastrar Perfil
        </button>
      </div>
    </div>
    <LoadingData v-if="isLoadingData" class="my-3" />
    <ListProfiles
      v-else
      :profiles="profiles"
      @createEditProfile="createEditProfile"
    />
  </div>
</template>

<script>
import CreateEditProfileModal from '@/components/company/profiles/CreateEditProfileModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListProfiles from '@/components/company/profiles/ListProfiles.vue'

export default {
  name: 'Profiles',

  components: {
    CreateEditProfileModal,
    LoadingData,
    ListProfiles,
  },

  data() {
    return {
      isLoadingData: true,
      showCreateEditProfileModal: false,
      profiles: [],
      profileIdSelected: null,
    }
  },

  methods: {
    async getProfiles() {
      try {
        this.profiles = await this.$store.dispatch('getProfiles')
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    createEditProfile(profileId) {
      this.profileIdSelected = profileId || null
      this.showCreateEditProfileModal = true
    },

    closeModal(needReload) {
      if (needReload) {
        this.getProfiles()
      }
      this.showCreateEditProfileModal = false
    },
  },

  mounted() {
    this.getProfiles()
  },
}
</script>
